import getConfig from 'next/config';

import { accountsApi } from '../api/accountsApi';
import { isProtectedRoute } from '../constants/protectedRoutes';
import { fireToast } from '../helpers/Toasts';

const {
  publicRuntimeConfig: { FEATURE_DISABLE_LEGACY_SESSION },
} = getConfig();

async function userLogout(dispatchCallback: any, userLoggingOut: string) {
  try {
    if (!FEATURE_DISABLE_LEGACY_SESSION) {
      await accountsApi.logout();
    }

    dispatchCallback({
      type: 'CLEAR',
    });

    if (isProtectedRoute(location.pathname)) {
      location.assign('/');
    } else {
      fireToast({
        type: 'SUCCESS',
        text: `You're now logged out ${userLoggingOut}. Hope to see you soon!`,
      });
    }
  } catch (_error) {
    fireToast({
      type: 'ERROR',
      text: 'Oops! Something went wrong, please try again later',
    });
  }
}

export { userLogout };
